
import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-award-line',
      title: t('about.experience.title'),
      description: t('about.experience.description'),
      color: 'bg-blue-500'
    },
    {
      icon: 'ri-shield-check-line',
      title: t('about.certified.title'),
      description: t('about.certified.description'),
      color: 'bg-green-500'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('about.support.title'),
      description: t('about.support.description'),
      color: 'bg-purple-500'
    },
    {
      icon: 'ri-secure-payment-line',
      title: t('about.warranty.title'),
      description: t('about.warranty.description'),
      color: 'bg-orange-500'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('about.title')} <span className="text-[#FE5000]">{t('about.titleHighlight')}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t('about.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 text-center hover:shadow-lg transition-shadow duration-300 group">
              <div className={`w-16 h-16 ${feature.color} rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Statistics Section */}
        <div className="mt-16 bg-[#005776] rounded-3xl p-12">
          <div className="grid md:grid-cols-4 gap-8 text-center text-white">
            <div>
              <div className="text-4xl font-bold mb-2">500+</div>
              <div className="text-white/80">مشروع مكتمل</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">15+</div>
              <div className="text-white/80">سنة خبرة</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">50+</div>
              <div className="text-white/80">عميل راضي</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">24/7</div>
              <div className="text-white/80">دعم فني</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
